import axios from 'axios';

// Create Axios instance
const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {},
});

// Request Interceptor: inject token
api.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers['Authorization'] = token;
  }
  return config;
}, error => Promise.reject(error));

// Unified Response Interceptor
api.interceptors.response.use(
  response => response,
  error => {
    const status = error.response?.status;
    const currentPath = window.location.pathname;

    // Cegah redirect saat sudah di /login
    if ((status === 401 || status === 419) && currentPath !== '/login') {
      localStorage.removeItem('token');
      window.location.href = '/login';
      console.warn('Sesi kamu telah berakhir. Silakan login kembali.');
    }

    if (status === 404) {
      return Promise.resolve(error.response);
    }

    return Promise.reject(error);
  }
);


export default api;
